import { z } from "zod";
import { Throwable } from "@wss/error-tracking/throwable";

type IsInEuropeanUnionResponse = { returnFlag: boolean };

export async function requestIsInEuropeanUnion(
  init: RequestInit,
): Promise<Throwable<IsInEuropeanUnionResponse>> {
  try {
    const url = new URL("/object/ip.cfc", window.location.origin);
    url.searchParams.append("method", "isEuropeanUnion");
    const response = await fetch(url.href, init);
    if (!response.ok) throw new Error(response.statusText);
    const data = await response.json();
    const schema = z.object({ returnFlag: z.boolean() });
    const parsed = schema.parse(data);
    return { isError: false, value: parsed };
  } catch (error) {
    return {
      isError: true,
      error: new Error("Something went wrong with the /object/ip.cfc request", {
        cause: error,
      }),
    };
  }
}
